<mat-toolbar class="admin-sidenav-toolbar fx-row-w-100 fx-v-center fx-gap-10"
             color="primary">
  <div class="fx-row fx-center pr-20" routerLink="/">
    <mat-icon class="brand-logo-toolbar btn-cursor" svgIcon="brand-logo"></mat-icon>
  </div>

  <!--  Breadcrumbs: loggedIn -->
  @if (loggedIn$ | async) {
    <span class="mat-subtitle-1 mb-0-i">Platform Admin / {{ breadcrumbs$ | async }}</span>
  } @else {
    <span class="flex-spacer pr-50"></span>
    <span>Configuration and maintenance</span>
  }

  <span class="flex-spacer"></span>

  <!--  Context Selector and top menu: loggedIn -->
  @if (loggedIn$ | async) {
    <app-admin-context-selector></app-admin-context-selector>

    <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
      <mat-icon>more_vert</mat-icon>
    </button>

    <mat-menu #menu="matMenu">
      <button mat-menu-item (click)="logout()">
        <mat-icon>lock</mat-icon>
        <span>Logout</span>
      </button>
    </mat-menu>
  } @else {
    <mat-icon class="logged-out-info-icon">lock</mat-icon>
    <span class="mat-body-2">Please log in to continue</span>
  }
</mat-toolbar>
